/**
 * JM Le Gazel - Script avancé de validation du panier
 * Ce script empêche les commandes ne contenant que des produits à prix zéro
 * Intégration avec le message d'erreur existant du site
 */

(function() {
  // Exécution au chargement du DOM
  document.addEventListener('DOMContentLoaded', function() {
    // Surveiller le bouton de paiement et la soumission du formulaire de panier
    setupCartValidation();
    
    // Observer les changements dynamiques dans le panier (par exemple lors de l'ajout via Ajax)
    observeCartChanges();
  });

  /**
   * Mise en place des écouteurs d'événements pour la validation du panier
   */
  function setupCartValidation() {
    // Formulaires de panier standard
    const cartForms = document.querySelectorAll('form[action="/cart"], form[action^="/cart/"], form[action*="checkout"]');
    
    cartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        validateCartBeforeSubmit(e, form);
      });
    });
    
    // Boutons de paiement spécifiques
    const checkoutButtons = document.querySelectorAll('[name="checkout"], [href="/checkout"], [href*="/checkout"], .checkout-button, .cart__checkout');
    
    checkoutButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        validateCartBeforeCheckout(e);
      });
    });
  }

  /**
   * Observer les changements dans le panier pour les applications Ajax
   */
  function observeCartChanges() {
    // Observer le corps du document pour détecter les éléments de paiement ajoutés dynamiquement
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (node.nodeType === 1) { // Seulement les éléments
              // Rechercher les boutons de paiement nouvellement ajoutés
              const newCheckoutButtons = node.querySelectorAll('[name="checkout"], [href="/checkout"], [href*="/checkout"], .checkout-button, .cart__checkout');
              
              if (newCheckoutButtons.length > 0) {
                newCheckoutButtons.forEach(button => {
                  button.addEventListener('click', function(e) {
                    validateCartBeforeCheckout(e);
                  });
                });
              }
            }
          }
        }
      });
    });
    
    // Observer tout le corps du document
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Valide le panier avant de soumettre le formulaire
   */
  function validateCartBeforeSubmit(event, form) {
    // Empêcher la soumission immédiate
    event.preventDefault();
    
    // Vérifier le panier
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (isInvalidCart(cart)) {
          showCartError();
          return false;
        } else {
          // Panier valide, poursuivre la soumission
          form.submit();
        }
      })
      .catch(error => {
        console.error('Erreur lors de la vérification du panier:', error);
        // En cas d'erreur, permettre la soumission pour éviter de bloquer l'utilisateur
        form.submit();
      });
  }

  /**
   * Valide le panier avant de rediriger vers le paiement
   */
  function validateCartBeforeCheckout(event) {
    // Empêcher la redirection immédiate
    event.preventDefault();
    
    // Vérifier le panier
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (isInvalidCart(cart)) {
          showCartError();
          return false;
        } else {
          // Panier valide, poursuivre vers le paiement
          window.location.href = '/checkout';
        }
      })
      .catch(error => {
        console.error('Erreur lors de la vérification du panier:', error);
        // En cas d'erreur, permettre la redirection pour éviter de bloquer l'utilisateur
        window.location.href = '/checkout';
      });
  }

  /**
   * Vérifie si le panier est invalide (contient uniquement des produits à prix nul)
   */
  function isInvalidCart(cart) {
    // Panier vide
    if (!cart.items || cart.items.length === 0) {
      return false;
    }
    
    // Vérifier si le total du panier est 0
    if (cart.total_price === 0) {
      return true;
    }
    
    // Vérifier s'il y a au moins un produit avec un prix supérieur à 0
    const hasNonZeroProduct = cart.items.some(item => item.price > 0);
    
    // Panier invalide si tous les produits sont à prix zéro
    return !hasNonZeroProduct;
  }
  
  /**
   * Affiche le message d'erreur existant ou un message personnalisé
   */
  function showCartError() {
    // Chercher le message d'erreur existant dans la page
    const existingErrorMessage = document.getElementById('zeroCartText');
    
    if (existingErrorMessage) {
      // Afficher le message d'erreur existant
      existingErrorMessage.classList.remove('hide');
      existingErrorMessage.classList.add('show');
      
      // Faire défiler jusqu'au message si nécessaire
      existingErrorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // Dans le cas du drawer de panier, s'assurer qu'il reste ouvert
      const cartDrawer = document.querySelector('.drawer.drawer--right');
      if (cartDrawer) {
        cartDrawer.classList.add('drawer--is-open');
      }
      
      // S'assurer que le bouton de paiement est désactivé
      const checkoutWrapper = document.getElementById('cart__checkout-wrapper');
      if (checkoutWrapper) {
        checkoutWrapper.style.opacity = '0.5';
        checkoutWrapper.style.pointerEvents = 'none';
      }
      
      // Réactiver après 10 secondes pour éviter de bloquer complètement l'interface
      setTimeout(function() {
        if (existingErrorMessage.classList.contains('show')) {
          existingErrorMessage.classList.remove('show');
          existingErrorMessage.classList.add('hide');
          
          if (checkoutWrapper) {
            checkoutWrapper.style.opacity = '';
            checkoutWrapper.style.pointerEvents = '';
          }
        }
      }, 10000);
      
    } else {
      // Message d'erreur de secours si l'élément existant n'est pas trouvé
      const errorContainer = document.createElement('div');
      errorContainer.className = 'cart-error-message';
      errorContainer.style.cssText = 'position:fixed; top:20%; left:50%; transform:translateX(-50%); background-color:#f8d7da; color:#721c24; padding:20px; border-radius:5px; box-shadow:0 0 10px rgba(0,0,0,0.2); z-index:9999; max-width:80%; text-align:center; font-size:16px;';
      
      // Message d'erreur en français (comme le message original)
      errorContainer.innerHTML = `
        <div style="margin-bottom:15px; font-weight:bold;">Impossible de procéder au paiement</div>
        <div>Nous ne pouvons pas valider un panier à 0.00 EUR. Ajoutez également au panier un article physique comme des Souliers ou une Maroquinerie pour que nous puissions réaliser la patine choisie.</div>
        <button style="margin-top:20px; padding:8px 15px; background-color:#482c54; color:white; border:none; border-radius:4px; cursor:pointer;">Fermer</button>
      `;
      
      // Ajouter au DOM
      document.body.appendChild(errorContainer);
      
      // Gérer la fermeture du message
      const closeButton = errorContainer.querySelector('button');
      closeButton.addEventListener('click', function() {
        document.body.removeChild(errorContainer);
      });
      
      // Fermer automatiquement après 10 secondes
      setTimeout(function() {
        if (document.body.contains(errorContainer)) {
          document.body.removeChild(errorContainer);
        }
      }, 10000);
    }
    
    return false;
  }
})();